angular.module('jv.AuthApps.Transformations', ['jv.AuthApps.Namespace'])
    .factory('AuthAppsData', function() {
        return function(label, value, basicType, opts) {
            opts = opts || {};
            opts.possibleValues = opts.possibleValues || [];
            opts.type = opts.type || 'uneditable';
            this.label = label;
            this.value = value;
            this.basicType = basicType;
            this.possibleValues = opts.possibleValues;
            this.type = opts.type;
            this.platformId=opts.platformId;
            this.className=opts.className;
            this.connectUrl=opts.connectUrl;
            this.jhireBaseUrl=opts.jhireBaseUrl;
            this.sourceBaseUrl=opts.sourceBaseUrl;
            this.authUrl=opts.authUrl;
            this.active = opts.active;
        };
    })
    .factory('noop', [function() {
        return angular.noop;
    }])
    .value('authApps',{'LINKEDIN':i18n['LINKEDIN'],'FACEBOOK':i18n['FACEBOOK'],'TWITTER':i18n['TWITTER'],'GOOGLE':i18n['GMAIL'],'YAHOO':i18n['YAHOO'],'GOOGLE_CALENDAR':i18n['GOOGLECALENDAR'],'GOOGLE_APPS':i18n['GOOGLEAPPS'],'TALENTWISE':i18n['TALENTWISE'],'HIRERIGHT':i18n['HIRERIGHT'],'DOCUSIGN':i18n['DOCUSIGN'],'BROADBEAN':i18n['BROADBEAN'],'LINKEDIN_RSC':i18n['LINKEDIN_RSC'],'OFFICE_365':i18n['OFFICE_365']})
    .factory('AuthAppsGETTransform', ['AuthAppsData', 'authApps',function(AuthAppsData,authApps) {
        return function(responseData) {
            var array ={'a_socialNetworks':[],'b_email':[],'c_integrations':[]};
            angular.forEach(responseData.authAppStatus, function(obj) {
                if(!obj.active && obj.active === false) {
                    // This condition shows the re-authorize option (obj.active is false and not undefined)
                    obj.active = false;
                } else {
                    //If obj.active is undefined, it is treated the same as being active
                    obj.active = true;
                }
                if(obj.platform==='LINKEDIN' || obj.platform==='FACEBOOK' || obj.platform==='TWITTER'){
                    array.a_socialNetworks.push(new AuthAppsData(authApps[obj.platform], obj.connected, 'socialTemplate', {type: 'socialTemplate',platformId:obj.platformId,className:obj.platform,active:obj.active,connectUrl:responseData.connectUrl,jhireBaseUrl:responseData.jhireBaseUrl,sourceBaseUrl:responseData.sourceBaseUrl}));
                }
                else if(obj.platform==='GOOGLE' || obj.platform==='YAHOO'){
                    array.b_email.push(new AuthAppsData(authApps[obj.platform], obj.connected, 'socialTemplate', {type: 'socialTemplate',platformId:obj.platformId,className:obj.platform,active:obj.active,connectUrl:responseData.connectUrl,jhireBaseUrl:responseData.jhireBaseUrl,sourceBaseUrl:responseData.sourceBaseUrl,authUrl:obj.authUrl}));
                }
                else  if(obj.platform==='GOOGLE_CALENDAR' || obj.platform==='GOOGLE_APPS' || obj.platform==='HIRERIGHT' || obj.platform==='DOCUSIGN' || obj.platform==='BROADBEAN'|| obj.platform==='LINKEDIN_RSC' || obj.platform ==='OFFICE_365'){
                    array.c_integrations.push(new AuthAppsData(authApps[obj.platform], obj.connected, 'socialTemplate', {type: 'socialTemplate',platformId:obj.platformId,className:obj.platform,active:obj.active,connectUrl:responseData.connectUrl,jhireBaseUrl:responseData.jhireBaseUrl,sourceBaseUrl:responseData.sourceBaseUrl,authUrl:obj.authUrl}));
                }
                else  if(obj.platform==='TALENTWISE'){
                    array.c_integrations.push(new AuthAppsData(authApps[obj.platform], obj.connected, 'socialTemplate', {type: 'socialTemplate',platformId:obj.platformId,className:'icon icon-sterlingone-active xx-large TALENTWISE',active:obj.active,connectUrl:responseData.connectUrl,jhireBaseUrl:responseData.jhireBaseUrl,sourceBaseUrl:responseData.sourceBaseUrl,authUrl:obj.authUrl}));
                }
            });
            return array;
        };
    }])
.factory('AuthAppsPOSTTransform', [function() {
        return function(pId,dataToSave){
            var obj={};
            obj.action=dataToSave.action;
            if(obj.action ==='CONNECT'){
                if(pId===59){
                    obj.socId=dataToSave.socId;
                }else if(pId===53 || pId===0){
                    obj.socId=dataToSave.socId;
                    obj.sSec=dataToSave.sSec;
                }else if(pId === 72){
                    obj.username = dataToSave.username;
                    obj.password = dataToSave.password;
                    obj.accountId = dataToSave.accountId;
                }else if (pId===74) {
                    obj.socId=dataToSave.socId;
                }
            }

            return obj;
        };
    }])
    .value('identity', angular.identity);
